<template>
    <div>

        <TextBanner>
       <p> Die Internationale Raumstation, kurz ISS, ist das <b>größte menschengemachte Objekt</b> im All.
           </p>
        <b>Vergleichen Sie die ISS mit bekannten Objekten, drehen und zoomen Sie dafür das Modell.</b>
        </TextBanner>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_010_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_010_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>

        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {

                radiusLimits: [6, 200],
                position: [1,1.65,20],   //[0,1.5,70   //21.10. 14h [0.88,1.65,10]
                target: [0,0,1.5],       //[0,0,1.5]        //21.10. 14h [0,0,1.5]
            },
            

            iss: {


                Empty: {
                    sonne: {
                        fade: true,
                        visible: false
                    },
                },

                erde_pivot: {
                    erde: {
                        fade: true,
                        visible: false
                    },
                },

                Label_BG_109m: {
                    visible: true,
                    Typo_109m: {
                        visible: true
                    }

                },
                Pfeil_109m: {
                    visible: true,
                },
                

                Label_BG_73m: {
                    visible: true,
                    Typo_73m: {
                        visible: true,
                    }

                },
                Pfeil_73m: {
                    visible: true,
                },

                kontur_flugzeug: {
                    visible: true,
                },

                kontur_flugzeug_seite: {
                    visible: true,
                },

                kontur_fussballfeld: {
                    visible: true,
 
                },

                kontur_auto: {
                    visible: true,
                },

                kontur_astronaut: {
                    visible: true,
                },

            },
           
        },
        babylonReady: function () { 
        // this.$audioController.initTrack('loop', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);   //'speaker'
        //this.$audioController.initTrack('speaker', require('./../assets/audio/News_Loop3.mp3'), true, false);   //'speaker'


        //this.$babylonController.setCameraRadiusLimit(5.5,200);
   

        this.$babylonController.goToAnimation("spacex_anim", 0)

        this.$babylonController.goToAnimation("Solarpanels_rechts_anim", 0);
        this.$babylonController.goToAnimation("Solarpanels_links_anim", 0);
        this.$babylonController.goToAnimation("thermo_rechts_anim", 0);
        this.$babylonController.goToAnimation("thermo_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_1_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_2_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_3_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_4_rechts_anim", 0);
        this.$babylonController.goToAnimation("Panel_1_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_2_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_3_links_anim", 0);
        this.$babylonController.goToAnimation("Panel_4_links_anim", 0);
        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
